import { useState, useEffect } from "react";
import axios from "axios";
import { Truck, ShoppingCart } from "lucide-react";

import { BACKEND_URL } from "../../apiConfig";

export default function VendorScheduleWidget() {
  const [schedule, setSchedule] = useState({ day: "", order_today: [], delivery_today: [] });

  useEffect(() => {
    const token = localStorage.getItem("token");
    axios.get(`${BACKEND_URL}/api/vendors/schedule/today`, { headers: { Authorization: `Bearer ${token}` } })
      .then(res => setSchedule(res.data))
      .catch(() => {});
  }, []);

  return (
    <div className="flex flex-col h-full bg-white rounded-lg border border-zinc-200 overflow-hidden">
      <div className="bg-indigo-600 text-white text-[11px] font-bold px-2 py-1 text-center">
        Vendors - {schedule.day}
      </div>
      <div className="flex flex-1 min-h-0">
        {/* Order Today */}
        <div className="flex-1 min-w-0 border-r border-zinc-200 flex flex-col">
          <div className="bg-amber-50 text-amber-700 text-[10px] font-bold px-1.5 py-0.5 flex items-center gap-1 border-b border-zinc-100">
            <ShoppingCart className="w-3 h-3" /> Order
          </div>
          <div className="flex-1 min-w-0 overflow-auto px-1 py-0.5">
            {schedule.order_today.length === 0 ? (
              <div className="text-[10px] text-zinc-400 text-center py-1">None</div>
            ) : (
              schedule.order_today.map((v, i) => (
                <div key={v.id || v.name || i} className="text-[10px] text-zinc-700 py-0.5 border-b border-zinc-50 last:border-0 truncate" title={v.name}>
                  {v.name}
                </div>
              ))
            )}
          </div>
        </div>
        {/* Delivery Today */}
        <div className="flex-1 min-w-0 flex flex-col">
          <div className="bg-green-50 text-green-700 text-[10px] font-bold px-1.5 py-0.5 flex items-center gap-1 border-b border-zinc-100">
            <Truck className="w-3 h-3" /> Delivery
          </div>
          <div className="flex-1 min-w-0 overflow-auto px-1 py-0.5">
            {schedule.delivery_today.length === 0 ? (
              <div className="text-[10px] text-zinc-400 text-center py-1">None</div>
            ) : (
              schedule.delivery_today.map((v, i) => (
                <div key={v.id || v.name || i} className="text-[10px] text-zinc-700 py-0.5 border-b border-zinc-50 last:border-0 truncate" title={v.name}>
                  {v.name}
                </div>
              ))
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
